<script setup>
  import gsap from 'gsap';

  const { h1, color } = defineProps({ h1: Boolean, black: Boolean });

  // const container = ref();
  // const inner = ref();

  // const loadComplete = inject('loadComplete');
  // let visible = false;

  // watch(loadComplete, (value) => {
  //   if (loadComplete.value && visible) {
  //     show();
  //   }
  // });

  // useTelescope(container, {
  //   visible: () => {
  //     visible = true;
  //     if (loadComplete.value) show();
  //   },
  //   partial: () => {
  //     visible = false;
  //   },

  //   hidden: () => {
  //     visible = false;
  //   },
  // });

  // function show() {
  //   gsap.killTweensOf(container.value);
  //   gsap.to(inner.value, { duration: 1.42, x: 0.0, force3D: true, ease: 'cubic.inOut' });
  // }

  // onBeforeUnmount(() => {
  //   gsap.killTweensOf(inner.value);
  // });
</script>

<!----------------------------------------------------------------------------->

<template>
  <div class="title-container">
    <div class="inner">
      <!-- <ShowAnimation class="animation-container" fadeOnly> -->
      <h1 v-if="h1" :class="{ black }">
        <Ticker :speed="1.5" :scroll="2.5"
          ><span><slot /></span
        ></Ticker>
      </h1>
      <h2 v-else :class="{ black }">
        <Ticker :speed="1.5" :scroll="2.5"
          ><span><slot /></span>
        </Ticker>
      </h2>
      <!-- </ShowAnimation> -->
    </div>
  </div>
</template>

<!----------------------------------------------------------------------------->

<style lang="scss" scoped>
  // .inner {
  //   transform: translateX(100vw);
  // }

  h1,
  h2 {
    position: relative;
    margin-bottom: px(-149);

    font-size: px(400);
    color: white;

    &.black {
      color: $black;
    }

    @include break-medium {
      margin-bottom: px(-129);
      font-size: px(350);
    }

    @include break-small {
      margin-bottom: px(-80);
      font-size: px(323);
    }

    @include break-phone {
      margin-bottom: px(-95);
    }
  }

  // @include break-medium {
  //   section {
  //     padding-top: px(72);
  //     margin-bottom: px(-154);
  //   }

  //   h1,
  //   h2 {
  //     font-size: px(350);
  //   }
  // }

  // @include break-small {
  //   section {
  //     padding-top: px(64);
  //     margin-bottom: px(-65);
  //   }

  //   h1,
  //   h2 {
  //     font-size: px(323);
  //   }
  // }
</style>
